import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=2b7e1f54&scoped=true&"
import script from "./Analytics.vue?vue&type=script&lang=js&"
export * from "./Analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7e1f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2b7e1f54', component.options)
    } else {
      api.reload('2b7e1f54', component.options)
    }
    module.hot.accept("./Analytics.vue?vue&type=template&id=2b7e1f54&scoped=true&", function () {
      api.rerender('2b7e1f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/adsetprotos/Analytics.vue"
export default component.exports